// extracted by mini-css-extract-plugin
module.exports = {"inlineItem":"KeyValue-module__inlineItem--269Zi","valueHighlighted":"KeyValue-module__valueHighlighted--bZ2Qz","valueWithError":"KeyValue-module__valueWithError--ijGVW"};